module.exports = __webpack_public_path__ + "img/guidelines-05.009f801f.png";